var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page users-edit-page" }, [
    _c("div", { staticClass: "edit-area" }, [
      _vm.item
        ? _c(
            "form",
            {
              staticClass: "grid",
              attrs: { "data-interactive-check": "true" }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "cell" }, [
                  _c("div", { staticClass: "edit-id" }, [
                    _vm._v(
                      "\r\n                        " +
                        _vm._s(_vm.id) +
                        "\r\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "stub", staticStyle: { width: "120px" } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "button primary",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.onSave($event)
                          }
                        }
                      },
                      [_c("span", { staticClass: "mif-checkmark mif-lg" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button primary",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.onCancel($event)
                          }
                        }
                      },
                      [_c("span", { staticClass: "mif-cancel mif-lg" })]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "cell-sm-full cell-md-8" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.title,
                        expression: "item.title"
                      }
                    ],
                    attrs: {
                      "data-validate": "required minlength=6",
                      type: "text",
                      "data-clear-button": "false",
                      "data-role": "input",
                      "data-prepend": "Τίτλος: "
                    },
                    domProps: { value: _vm.item.title },
                    on: {
                      keyup: _vm.keyMonitor,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "title", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell-full" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.description,
                        expression: "item.description"
                      }
                    ],
                    attrs: {
                      "data-validate": "required minlength=6",
                      type: "text",
                      "data-clear-button": "false",
                      "data-role": "input",
                      "data-prepend": "Περιγραφή: "
                    },
                    domProps: { value: _vm.item.description },
                    on: {
                      keyup: _vm.keyMonitor,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "description", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell-full" }, [
                  _c("h6", [_vm._v("Gallery")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "cell-full",
                        staticStyle: { display: "flex" }
                      },
                      _vm._l(_vm.imageUrls, function(img, idx) {
                        return _c(
                          "div",
                          { key: idx, staticStyle: { "margin-right": "10px" } },
                          [
                            _c("img", {
                              staticStyle: { width: "80px", height: "80px" },
                              attrs: { src: _vm.toFullUrl(img), alt: "" },
                              on: {
                                error: _vm.setAltImg,
                                click: function($event) {
                                  return _vm.onRemoveImage(img)
                                }
                              }
                            })
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell-full" }, [
                      _c("input", {
                        staticClass: "mb-4",
                        attrs: {
                          type: "file",
                          multiple: "",
                          "data-role": "file",
                          "data-prepend": "Photo files:"
                        },
                        on: {
                          change: function($event) {
                            return _vm.processFilesToUpload($event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button primary",
                          attrs: {
                            disabled:
                              !_vm.selectedPhotoFiles ||
                              _vm.selectedPhotoFiles.length == 0
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.onUploadFiles()
                            }
                          }
                        },
                        [_c("span", [_vm._v("Upload Photos")])]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button primary",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.onSave($event)
                        }
                      }
                    },
                    [_c("span", { staticClass: "mif-checkmark mif-lg" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button primary",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.onCancel($event)
                        }
                      }
                    },
                    [_c("span", { staticClass: "mif-cancel mif-lg" })]
                  )
                ])
              ])
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }